import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App'
// Force Meta Pixel injection into <head> immediately
;
(function injectMetaPixel() {
  if (typeof window === 'undefined') return;
  if ((window as any).fbq) return;
  // Create and inject the Meta Pixel script
  const pixelScript = document.createElement('script');
  pixelScript.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '780668617738771');
    fbq('track', 'PageView');
  `;
  document.head.insertBefore(pixelScript, document.head.firstChild);
  // Create and inject noscript fallback
  const noscript = document.createElement('noscript');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=780668617738771&ev=PageView&noscript=1';
  noscript.appendChild(img);
  document.head.appendChild(noscript);
})();
render(<App data-id="element-132" />, document.getElementById('root'));